export default "<span class=\"badgeStyle\">\r\n  {{ count }}\r\n</span>\r\n";